import React from "react";
import dynamic from "next/dynamic";
import { NextPage } from "next";

const TestDetailsContainer = dynamic(
    () => import("containers/Test/TestDetailsContainer"),
    { ssr: false }
);

const GenerateReport: NextPage = () => <TestDetailsContainer />;

export default GenerateReport;
